import {BzIconDef} from "@bringoz/ui";
import {bzIconSortAsc, bzIconSortDesc} from "@bringoz/ui/icons";
import {SiteFiltersType} from "../../../commons/types/site-filters.type";
import {SortType} from "../../../commons/types/sort.type";
import {ThreePLServicesGroup, ThreePLServicesSortName} from "../models/threepl-services-list.model";

export const THREE_PL_SERVICES_PAGE_SIZE = 30;

export const THREE_PL_SERVICES_INCLUDE_FILTERS: SiteFiltersType[] = [
  SiteFiltersType.accountIds, SiteFiltersType.branchIds, SiteFiltersType.depotIds, SiteFiltersType.serviceAreaIds,
  SiteFiltersType.dateRangeTemplateType, SiteFiltersType.providerTypes, SiteFiltersType.supplyAccountIds,
  SiteFiltersType.serviceTypes, SiteFiltersType.programTypes,
];

export const THREE_PL_SERVICES_GROUP_TABS: {id: string; label: string; key: string}[] = [
  {id: "TOTAL", label: "Total", key: "total"},
  {id: "UNASSIGNED", label: "Not-Assigned", key: "unassigned"},
  {id: "ASSIGNED", label: "Assigned", key: "assigned"},
  {id: "STARTED", label: "Started", key: "started"},
  {id: "CANCELED", label: "Canceled", key: "canceled"},
  {id: "COMPLETED", label: "Completed", key: "completed"},
  {id: "RISK", label: "At Risk", key: "risk"},
];

export const THREE_PL_SERVICES_GROUP_MENU: {id: string; label: string; key: string}[] = [
  {id: "TOTAL", label: "Total", key: "total"},
  {id: "UNASSIGNED", label: "Unassigned", key: "unAssigned"},
  {id: "ASSIGNED", label: "Assigned", key: "assigned"},
  {id: "STARTED", label: "Started", key: "started"},
  {id: "CANCELED", label: "Canceled", key: "canceled"},
  {id: "COMPLETED", label: "Completed", key: "completed"},
  {id: "RISK", label: "Risk", key: "risk"},
];

export const THREE_PL_SERVICES_EXPORT_LOCATION_FIELDS = [
  "pickupAddress", "pickupStreet", "pickupHouse", "pickupEntrance", "pickupFloor", "pickupApt", "pickupCity", "pickupZipCode",
  "pickupCountry", "dropoffAddress", "dropoffStreet", "dropoffHouse", "dropoffEntrance", "dropoffFloor", "dropoffApt",
  "dropoffCity", "dropoffZipCode", "dropoffCountry",
];

export const THREE_PL_SERVICES_EXPORT_FIELDS: [string, string][] = [
  ["serviceId", "deliveryId"], ["orderId", "orderId"], ["externalId", "externalId"], ["accountName", "accountName"],
  ["status", "status"], ["pickupStartTime", "pickupStartTime"], ["pickupEndTime", "pickupEndTime"],
  ["dropoffStartTime", "dropoffStartTime"], ["dropoffEndTime", "dropoffEndTime"],
  ...THREE_PL_SERVICES_EXPORT_LOCATION_FIELDS.slice(0, 9).map((f): [string, string] => [f, f]),
  ["pickupPhone", "pickupPhone"],
  ...THREE_PL_SERVICES_EXPORT_LOCATION_FIELDS.slice(9).map((f): [string, string] => [f, f]),
  ["dropoffPhone", "dropoffPhone"], ["pickupContact", "pickupContact"], ["dropoffContact", "dropoffContact"],
  ["createdTime", "createdTime"], ["distance", "distance"], ["serviceType", "serviceType"], ["price", "price"],
  ["omsOrderExternalId", "omsOrderExternalId"], ["programName", "programName"], ["branchNames", "branchNames"],
  ["pickupServiceAreaIds", "pickupServiceAreaIds"], ["dropoffServiceAreaIds", "dropoffServiceAreaIds"], ["carrier", "carrier"],
  ["taskApprovalStatus", "taskApprovalStatus"], ["timeToDeliver", "timeToDeliver"], ["notes", "notes"],
];

export const ACCOUNT_THREE_PL_SERVICES_PAGE_SIZE = 20;

export const THREE_PL_SERVICES_MOBILE_FETCH_AHEAD = 5;

export const THREE_PL_SERVICES_SORT_ICONS: Record<string, BzIconDef> = {asc: bzIconSortAsc, desc: bzIconSortDesc};

export const THREE_PL_SERVICES_SKELETON_ROWS_FIRST_PAGE = 10;

export const THREE_PL_SERVICES_SKELETON_ROWS_NEXT_PAGE = 3;

export const THREE_PL_SERVICES_TABLE_DEFAULT_WIDTHS: Record<string, number> = {
  "col-name": 250, "col-order-id": 150, "col-branches": 150, "col-account": 250, "col-carrier": 250, "col-location": 250,
  "col-approval-status": 150, "col-contact": 150, "col-program-type": 150, "col-eta": 150, "col-time-to-deliver": 150,
  "col-distance": 150, "col-service-areas": 150, "col-time-window": 250, "col-price": 150, "col-notes": 250, "col-created": 150,
};

export const THREE_PL_SERVICES_TABLE_DYNAMIC_COLUMN_WIDTH = 150;

export const THREE_PL_SERVICES_SKELETON_CELLS: {column?: string; cls: string; lines: number}[] = [
  {cls: "col-name", lines: 2},
  {column: "orderId", cls: "col-order-id", lines: 1},
  {column: "operationalUnits", cls: "col-branches", lines: 1},
  {column: "account", cls: "col-account", lines: 1},
  {column: "supplierAccount", cls: "col-carrier", lines: 1},
  {column: "location", cls: "col-location", lines: 2},
  {column: "taskApprovalStatus", cls: "col-approval-status", lines: 2},
  {column: "contact", cls: "col-contact", lines: 2},
  {column: "programType", cls: "col-program-type", lines: 1},
  {column: "eta", cls: "col-eta", lines: 1},
  {column: "timeToDeliver", cls: "col-time-to-deliver", lines: 1},
  {column: "distance", cls: "col-distance", lines: 1},
  {column: "serviceAreas", cls: "col-service-areas", lines: 2},
  {column: "timeWindow", cls: "col-time-window", lines: 2},
  {column: "price", cls: "col-price", lines: 1},
  {column: "notes", cls: "col-notes", lines: 1},
  {column: "created", cls: "col-created", lines: 1},
];

export const THREE_PL_SERVICE_STATUS_ALL = "__all__";

export const THREE_PL_SERVICES_CHANNEL = "thirdPartyService";

export const THREE_PL_SERVICES_SORT_VALUES: Record<ThreePLServicesSortName, Record<SortType, string>> = {
  sortEta: {asc: "eta,asc", desc: "eta,desc"},
  sortCreatedAt: {asc: "createdAt,asc", desc: "createdAt,desc"},
};

export const THREE_PL_SERVICES_GROUP_STATUSES: ThreePLServicesGroup[] = ["UNASSIGNED", "ASSIGNED", "STARTED", "CANCELED", "COMPLETED", "RISK"];
